import { t } from 'utils/getTranslations';
import { diffKind } from '@common/audit-trail/auditTrailFormat';
import { ValuePill } from './ValuePill';
import { ValuePreview } from './ValuePreviewDialog';

export function AuditTrailFieldRow({
    property,
    oldValue,
    newValue,
    oldLabel,
    newLabel,
    entityTypeLabel,
    onPreview,
}: {
    property: string;
    oldValue: unknown;
    newValue: unknown;
    oldLabel?: string;
    newLabel?: string;
    entityTypeLabel: string;
    onPreview: (preview: ValuePreview) => void;
}) {
    const kind = diffKind(oldValue, newValue);
    const previewTitle = (suffix: string) => `${entityTypeLabel} · ${property} — ${suffix}`;
    const oldPillProps = {
        value: oldValue,
        label: oldLabel,
        previewTitle: previewTitle(t('audit-trail.previous-value')),
        onPreview,
    };
    const newPillProps = {
        value: newValue,
        label: newLabel,
        previewTitle: previewTitle(t('audit-trail.new-value')),
        onPreview,
    };

    return (
        <div className="border-grey-100 grid grid-cols-[172px_1fr] items-baseline gap-x-4 border-t py-[9px]">
            <div className="text-grey-600 truncate text-[13px] font-medium">{property}</div>
            <div className="flex flex-wrap items-center gap-2">
                {kind === 'update' && (
                    <>
                        <ValuePill variant="old" {...oldPillProps} />
                        <span className="new:text-muted-foreground text-sm text-[#C8C8C8]">→</span>
                        <ValuePill variant="new" {...newPillProps} />
                    </>
                )}
                {kind === 'add' && (
                    <>
                        <span className="new:text-muted-foreground new:text-caption text-[11px] text-[#B0B0B0]">
                            {t('audit-trail.set-to')}
                        </span>
                        <ValuePill variant="new" {...newPillProps} />
                    </>
                )}
                {kind === 'remove' && (
                    <>
                        <ValuePill variant="removed" {...oldPillProps} />
                        <span className="new:text-muted-foreground new:text-caption text-[11px] text-[#B0B0B0]">
                            {t('audit-trail.removed')}
                        </span>
                    </>
                )}
            </div>
        </div>
    );
}
